module.exports = __webpack_public_path__ + "img/Sensel.3575e218.jpg";